import React from 'react';
import GradebookViewer from '../../containers/Journal/GradebookViewer';
import DesignChallenge from '../../containers/Journal/DesignChallenge';
import ReflectionEditor from '../../containers/Journal/ReflectionEditor';
import DesignConceptHistory from '../../containers/Journal/DesignConceptHistory';
import JournalIntroViewer from '../../containers/Journal/JournalIntroViewer';

import {
  JOURNAL_INTRO,
  JOURNAL_DESIGN_CHALLENGE,
  JOURNAL_GRADEBOOK,
  JOURNAL_LOGS,
  JOURNAL_REFLECTION,
} from '../../constants/journal';

const JournalContent = ({ page }) => {
  switch (page) {
    case JOURNAL_INTRO:
      return <JournalIntroViewer />;
    case JOURNAL_DESIGN_CHALLENGE:
      return <DesignChallenge key="journal-challenge" />;
    case JOURNAL_GRADEBOOK:
      return <GradebookViewer key="journal-gradebook" />;
    case JOURNAL_REFLECTION:
      return <ReflectionEditor key="journal-reflection" />;
    case JOURNAL_LOGS:
      return <DesignConceptHistory key="journal-logs" />;
    default:
      return <div key="watermark" className="box watermark" />;
  }
};

export default JournalContent;
